import { render, staticRenderFns } from "./Sorter.vue?vue&type=template&id=0ce162cb&scoped=true"
import script from "./Sorter.vue?vue&type=script&lang=js"
export * from "./Sorter.vue?vue&type=script&lang=js"
import style0 from "./Sorter.vue?vue&type=style&index=0&id=0ce162cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce162cb",
  null
  
)

export default component.exports